// ============================================================
//  src/index.js
//  Mounts App, injects Google Fonts + Font Awesome at runtime
//  so public/index.html stays minimal.
// ============================================================
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

(function injectLinks() {
  const links = [
    { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
    { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,200..800&display=swap' },
    { rel: 'stylesheet', href: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css' },
  ];
  links.forEach((attrs) => {
    const el = document.createElement('link');
    Object.entries(attrs).forEach(([k, v]) => { el[k] = v; });
    document.head.appendChild(el);
  });
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
